module.exports = __webpack_public_path__ + "static/media/tab-8bit-chocolatey.7ccacc96.png";